function initFunCard() {
    const openBtn = document.querySelector('[data-fan-card-open]');
    const barcodeElement = document.querySelector('[data-fan-card-barcode]');
    const popup = document.querySelector('[data-fan-card-popup]');
    const canvas = popup ? popup.querySelector('canvas') : null;
    const closeBtn = popup ? popup.querySelector('button') : null;
    if (!openBtn || !barcodeElement || !popup || !canvas || !closeBtn)
        return;

    const barcodeNumber = barcodeElement.innerText;

    openBtn.addEventListener('click', () => {
        canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);

        QRCode.toCanvas(
            canvas,
            barcodeNumber,
            { width: 200 },
            function (error) {
                if (error) {
                    console.error(error);
                    return;
                }

                popup.classList.add('opened');
            }
        );
    });

    closeBtn.addEventListener('click', () => {
        popup.classList.remove('opened');
    });

    console.log(barcodeNumber);
}

document.addEventListener('DOMContentLoaded', initFunCard);
